import { ApiError, apiInstance, apiResponse, getLoadingState } from "../../Api"
import { ParametroPreProjetoModel, PreProjetoModel, OrientadorModel } from "./Model"

export const enviarFormulario = async (
  preProjeto: {
    tema: string,
    titulo: string,
    justificativa: string,
    desenvolvimento: string,
    bibliografia: string,
    professorId: Array<number>
  }): Promise<apiResponse<ApiError[]>> => {

  try {
    const response = await apiInstance.post(
      '/aluno/preprojeto/inscricao',
      {
        tema: preProjeto.tema,
        titulo: preProjeto.titulo,
        justificativa: preProjeto.justificativa,
        desenvolvimento: preProjeto.desenvolvimento,
        bibliografia: preProjeto.bibliografia,
        professorId: preProjeto.professorId
      }
    )
    return {
      data: [],
      status: getLoadingState(response.status)
    }
  } catch (e) {
    const status = e.response ? e.response.status : 500
    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    }
  }
}

export const editarFormulario = async (
  preProjeto: {
    tema: string,
    titulo: string,
    justificativa: string,
    desenvolvimento: string,
    bibliografia: string,
    professorId: Array<number>
  }): Promise<apiResponse<ApiError[]>> => {

  try {
    const response = await apiInstance.post(
      '/aluno/preprojeto/editar',
      {
        tema: preProjeto.tema,
        titulo: preProjeto.titulo,
        justificativa: preProjeto.justificativa,
        desenvolvimento: preProjeto.desenvolvimento,
        bibliografia: preProjeto.bibliografia,
        professorId: preProjeto.professorId
      }
    )
    return {
      data: [],
      status: getLoadingState(response.status)
    }
  } catch (e) {
    const status = e.response ? e.response.status : 500
    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    }
  }
}

export const buscarPreProjetoDoAlunoAtual = async ():
  Promise<apiResponse<PreProjetoModel | undefined>> => {

  try {
    const response = await apiInstance.get<PreProjetoModel>(
      '/aluno/preprojeto/resumo'
    )

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<PreProjetoModel>
  } catch (e) {
    const status = e.response ? e.response.status : 500

    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>
  }
}

export const getParamsPreProjeto = async ():
  Promise<apiResponse<ParametroPreProjetoModel | undefined>> => {

  try {
    const response = await apiInstance.get<ParametroPreProjetoModel>(
      '/preprojeto/parametros'
    )

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<ParametroPreProjetoModel>
  } catch (e) {
    const status = e.response ? e.response.status : 500

    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>
  }
}

export const getParamsPreProjetoPeloId = async (parametroId: number):
  Promise<apiResponse<ParametroPreProjetoModel | undefined>> => {

  try {
    const response = await apiInstance.get<ParametroPreProjetoModel>(
      `/funcionario/preprojetos/parametros/${parametroId}`
    )

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<ParametroPreProjetoModel>
  } catch (e) {
    const status = e.response ? e.response.status : 500

    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>
  }
}

export const criarNovoParametro = async (
  serie: string,
  dataDeInicio: string, horaDeInicio: string,
  dataDeFim: string, horaDeFim: string,
  dataDeInicioInscricoes: string, horaDeInicioInscricoes: string,
  dataDeFimInscricoes: string, horaDeFimInscricoes: string,
  dataDeInicioPF: string, horaDeInicioPF: string,
  dataDeFimPF: string, horaDeFimPF: string,
  dataDeInicioSF: string, horaDeInicioSF: string,
  dataDeFimSF: string, horaDeFimSF: string,
  dataDeInicioTF: string, horaDeInicioTF: string,
  dataDeFimTF: string, horaDeFimTF: string,
  observacao: string
): Promise<apiResponse<ApiError[]>> => {
  try {
    const response = await apiInstance.post('/funcionario/preprojetos/criarparametros',
      {
        serie,
        dataDeInicio: dataDeInicio + ' ' + horaDeInicio,
        dataDeFim: dataDeFim + ' ' + horaDeFim,
        dataDeInicioInscricoes: dataDeInicioInscricoes + ' ' + horaDeInicioInscricoes,
        dataDeFimInscricoes: dataDeFimInscricoes + ' ' + horaDeFimInscricoes,
        dataDeInicioPF: dataDeInicioPF + ' ' + horaDeInicioPF,
        dataDeFimPF: dataDeFimPF + ' ' + horaDeFimPF,
        dataDeInicioSF: dataDeInicioSF + ' ' + horaDeInicioSF,
        dataDeFimSF: dataDeFimSF + ' ' + horaDeFimSF,
        dataDeInicioTF: dataDeInicioTF + ' ' + horaDeInicioTF,
        dataDeFimTF: dataDeFimTF + ' ' + horaDeFimTF,
        observacao
      })
    return {
      data: [],
      status: getLoadingState(response.status)
    }
  } catch (e) {
    const status = e.response ? e.response.status : 500
    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    }
  }
}

export const editarParametro = async (
  id: number, serie: string,
  dataDeInicio: string, horaDeInicio: string,
  dataDeFim: string, horaDeFim: string,
  dataDeInicioInscricoes: string, horaDeInicioInscricoes: string,
  dataDeFimInscricoes: string, horaDeFimInscricoes: string,
  dataDeInicioPF: string, horaDeInicioPF: string,
  dataDeFimPF: string, horaDeFimPF: string,
  dataDeInicioSF: string, horaDeInicioSF: string,
  dataDeFimSF: string, horaDeFimSF: string,
  dataDeInicioTF: string, horaDeInicioTF: string,
  dataDeFimTF: string, horaDeFimTF: string,
  observacao: string
): Promise<apiResponse<ApiError[]>> => {
  try {
    const response = await apiInstance.post(
      '/funcionario/preprojetos/editarparametros',
      {
        id,
        serie,
        dataDeInicio: dataDeInicio + ' ' + horaDeInicio,
        dataDeFim: dataDeFim + ' ' + horaDeFim,
        dataDeInicioInscricoes: dataDeInicioInscricoes + ' ' + horaDeInicioInscricoes,
        dataDeFimInscricoes: dataDeFimInscricoes + ' ' + horaDeFimInscricoes,
        dataDeInicioPF: dataDeInicioPF + ' ' + horaDeInicioPF,
        dataDeFimPF: dataDeFimPF + ' ' + horaDeFimPF,
        dataDeInicioSF: dataDeInicioSF + ' ' + horaDeInicioSF,
        dataDeFimSF: dataDeFimSF + ' ' + horaDeFimSF,
        dataDeInicioTF: dataDeInicioTF + ' ' + horaDeInicioTF,
        dataDeFimTF: dataDeFimTF + ' ' + horaDeFimTF,
        observacao
      }
    )
    return {
      data: [],
      status: getLoadingState(response.status)
    }
  } catch (e) {
    const status = e.response ? e.response.status : 500
    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    }
  }
}

export const recuperarListaDeParametros = async (): Promise<apiResponse<ParametroPreProjetoModel[]>> => {

  try {
    const fetchResponse = await apiInstance.get<ParametroPreProjetoModel[]>(
      '/funcionario/preprojetos/listarparametros');

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<ParametroPreProjetoModel[]>;

  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: [],
      status: getLoadingState(status)
    } as apiResponse<ParametroPreProjetoModel[]>;
  }
};

export const getListaAlunosOrientacao = async ():
  Promise<apiResponse<OrientadorModel[] | undefined>> => {

  try {
    const response = await apiInstance.get<OrientadorModel[]>(
      '/professor/preprojeto/pendentes',
    )

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<OrientadorModel[]>
  } catch (e) {
    const status = e.response ? e.response.status : 500

    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>
  }
}

export const recuperarInformacoesPreProjeto = async (PreProjetoId: number):
  Promise<apiResponse<OrientadorModel | undefined>> => {

  try {
    const response = await apiInstance.get<OrientadorModel>(
      `/professor/preprojeto/${PreProjetoId}`
    )

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<OrientadorModel>
  } catch (e) {
    const status = e.response ? e.response.status : 500

    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>
  }
}

export const ppAprovar = async (
  PreProjetoId: number,
): Promise<apiResponse<ApiError[]>> => {

  try {
    const fetchResponce = await apiInstance.post(
      '/professor/preprojeto/aprovar',
      { PreProjetoId });
    return {
      data: [],
      status: getLoadingState(fetchResponce.status)
    };
  }
  catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    };
  }
};

export const ppReprovar = async (
  preprojetoId: number,
  justificativaDaRejeicao: string
): Promise<apiResponse<ApiError[]>> => {

  try {
    const fetchResponce = await apiInstance.post(
      '/professor/preprojeto/reprovar',
      {
        preprojetoId,
        justificativaDaRejeicao
      });
    return {
      data: [],
      status: getLoadingState(fetchResponce.status)
    };
  }
  catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    };
  }

};

export const getVagasRestantesProfessor = async (professorid: number):
  Promise<apiResponse<number | undefined>> => {

  try {
    const response = await apiInstance.get<number>(
      '/preprojeto/vagasdisponiveis',
      { params: { professorid } }
    )

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<number>
  } catch (e) {
    const status = e.response ? e.response.status : 500

    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>
  }
}

export const buscarTodosPreProjetosFuncionario = async (
  recusados: boolean, page: number, pageSize: number, search: string):
  Promise<apiResponse<PreProjetoModel[]>> => {

  try {
    const fetchResponse = await apiInstance.get<PreProjetoModel[]>(
      '/funcionario/preprojetos',
      { params: { recusados, page, pageSize, search } }
    );

    return {
      data: fetchResponse.data,
      status: getLoadingState(fetchResponse.status)
    } as apiResponse<PreProjetoModel[]>;

  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: [],
      status: getLoadingState(status)
    } as apiResponse<PreProjetoModel[]>;
  }
};

export const recuperarInformacoesPreProjetoFuncionario = async (preProjetoId: number):
  Promise<apiResponse<PreProjetoModel | undefined>> => {

  try {
    const response = await apiInstance.get<PreProjetoModel>(
      `/funcionario/preprojetos/${preProjetoId}`
    )

    return {
      data: response.data,
      status: getLoadingState(response.status)
    } as apiResponse<PreProjetoModel>
  } catch (e) {
    const status = e.response ? e.response.status : 500

    return {
      data: undefined,
      status: getLoadingState(status)
    } as apiResponse<undefined>
  }
}

export const ppAprovarFuncionario = async (
  preProjetoId: number, professorId: number
): Promise<apiResponse<ApiError[]>> => {

  try {
    const fetchResponce = await apiInstance.post(
      '/funcionario/preprojetos/aprovar',
      {
        preProjetoId,
        professorId
      });
    return {
      data: [],
      status: getLoadingState(fetchResponce.status)
    };
  } catch (e) {
    const status = e.response ? e.response.status : 500;

    return {
      data: e.response ? e.response.data : [],
      status: getLoadingState(status)
    };
  }
};